import { Link, useLocation } from 'react-router-dom';
import { cn } from '../ui-x';
import { isNavItemActive } from './navItems';

/**
 * One labelled nav group on the navy admin rail (reference: client.tsx).
 * Rendered by the desktop rail and by the mobile drawer, which shares the
 * rail's navy register.
 *
 * clientApp uses <NavLink> here, but its active class is computed from
 * useLocation rather than from the router — and react-router-dom is v5 in this
 * app, where NavLink takes `activeClassName` instead of v6's callback. Plain
 * <Link> keeps the same rendering and is version-agnostic.
 */
const MenuItems = ({ label, items, badge, collapsed, onNavigate, className }) => {
  const location = useLocation();

  return (
    <div className={className}>
      {label && !collapsed && (
        <div className='flex items-center justify-between px-3 pb-2'>
          <span className='text-[10px] font-semibold uppercase tracking-wider text-white/40'>
            {label}
          </span>
          {badge && (
            <span className='rounded bg-brand-orange/20 px-1.5 py-0.5 text-[9px] font-bold tracking-wider text-brand-orange'>
              {badge}
            </span>
          )}
        </div>
      )}

      <div className='space-y-1'>
        {items.map((item) => {
          const Icon = item.icon;
          const active = isNavItemActive(item, location.pathname);

          return (
            <Link
              key={item.key}
              to={item.path}
              onClick={onNavigate}
              title={collapsed ? item.label : undefined}
              className={cn(
                'group relative flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                collapsed && 'justify-center',
                active
                  ? 'bg-brand-navy-800 text-white'
                  : 'text-white/70 hover:bg-white/5 hover:text-white'
              )}
            >
              {active && (
                <span className='absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-brand-orange' />
              )}
              <Icon
                className={cn(
                  'h-4 w-4 shrink-0',
                  active
                    ? 'text-brand-orange'
                    : 'text-white/60 group-hover:text-white'
                )}
              />
              {!collapsed && <span className='truncate'>{item.label}</span>}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default MenuItems;
